import { createDialog } from '@/infrastructure/decorators/dialog';
export function createReportDialog() {
    return createDialog(() => import('../../presentation/components/CreateReport/CreateReportDialog.vue'));
}
